import type { CopilotCardSlotId } from "owa-copilot-ccf-store";

/**
 * The Copilot Card Framework slot at the top of the message list, above the nudges.
 *
 * Named for the place, not for a feature: Inbox Briefings triggers a card here today, and Mail
 * search is expected to as well. Whichever feature calls `lazyShowCopilotCard` most recently owns
 * the card, since a slot holds at most one.
 *
 * Exported so triggering features in other packages can target this slot without knowing where
 * `CopilotCardHost` is mounted — the slot id is the only thing linking a trigger to a mount point.
 */
export const mailListHeaderCopilotSlot = "mailListHeader" as CopilotCardSlotId;
